import { Box, Card } from "@mui/material";

import Keys from "../../static/keys.svg";

export default function LoginContainer({ children }: { children: any }) {
  return (
    <Box style={{ backgroundColor: "#1d2033", height: "100%" }}>
      <Box
        margin={"auto"}
        className="login"
        maxWidth={"sm"}
        justifyItems={"center"}
        justifyContent="center"
        display="flex"
        alignItems="center"
      >
        <Card
          style={{
            backgroundColor: "#1d2033",
            position: "relative",
            overflow: "visible",
          }}
          variant="outlined"
          sx={{ p: 4, flexGrow: 1, zIndex: 1 }}
        >
          <Card
            style={{ backgroundColor: "transparent", position: "absolute" }}
            variant="outlined"
            sx={{
              flexGrow: 1,
              top: "-0.5rem",
              left: "2rem",
              right: "2rem",
              height: "5px",
              zIndex: 0,
              borderBottom: "none",
              borderRadius: "5px 5px 0 0",
            }}
          ></Card>

          <img
            src={Keys}
            className="logo"
            style={{ top: "-10%" }}
            alt="Janus logo"
          />

          {children}
        </Card>
      </Box>
    </Box>
  );
}
